"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _underscore = require("underscore");
var _types = require("./types");
var _sources = require("../../utils/sources");
/**
 * Need to sync the broadcast sources with the status of sources in program which is from current scene
 * This is being handled in the backend when program is updated. We need to update the redux store w/ this update
 */
function syncBroadcastSources() {
  var scene = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState) {
    var _getState = getState(),
      sources = _getState.broadcastSources.sources;
    var _ref = scene || {},
      _ref$layers = _ref.layers,
      layers = _ref$layers === void 0 ? [] : _ref$layers;
    var liveBroadcastSources = (0, _sources.getBroadcastSourcesFromLayers)(layers, sources);
    // covert list to map for easy lookup
    var liveBroadcastSourcesMap = (0, _underscore.indexBy)(liveBroadcastSources, '_id');
    var updatedSources = sources.map(function (source) {
      var liveSource = liveBroadcastSourcesMap[source._id];
      source.hidden = !liveSource;
      return source;
    });
    dispatch({
      type: _types.BROADCAST_PROGRAM_SOURCES_SYNC,
      payload: updatedSources
    });
  };
}
var _default = exports["default"] = syncBroadcastSources;